<template>
  <div>
    <v-dialog
      v-model="isLiveConsoleDialogOpen"
      scrollable
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <!-- <div class="container"> -->
      <v-card color="#F8F8FA">
        <!-- <v-toolbar flat dark color="primary"> -->
        <!-- <v-toolbar-title>
          <v-icon left>mdi-youtube</v-icon>แก้ไข/เพิ่ม การถ่ายทอดสด
        </v-toolbar-title>-->
        <!-- <v-spacer></v-spacer> -->
        <!-- <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn icon dark @click="isOpen=false" v-on="on">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
          <span class="subtitle-1">ปิดหน้าต่าง</span>
        </v-tooltip>-->
        <!-- </v-toolbar> -->
        <div class="header-label">
          <v-btn icon dark @click="closeLiveConsoleDialogAndClearStep" class="close_dialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <div class="header-label logo">
          <img src="@/assets/layout/nerdof_live.png" class="logo-nerdof" />
          <v-btn
            v-if="step==3"
            class="close_dialog end_boardcast"
            color="error"
            dark
            rounded
            height="33px"
            @click="stopStream"
          >
            <v-icon left>mdi-phone-hangup</v-icon>End Broadcast
          </v-btn>
        </div>
        <!-- <v-toolbar flat dark color="white">
        <v-toolbar-title>
          <img src="@/assets/layout/nerdof_live.png" class="sizeImgDialogAdd" />
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn icon dark @click="isLiveDialogOpen=false" v-on="on">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
          <span class="subtitle-1">ปิดหน้าต่าง</span>
        </v-tooltip>
        </v-toolbar>-->
        <!-- <v-card-text class="dialogStyle"> -->
        <!-- <v-form ref="form" v-model="valid" lazy-validation>
          <v-row>
            <v-col>
              <p class="title mb-0">{{$vuetify.lang.t("$vuetify.liveName")}}</p>
              <v-text-field
                v-model="name"
                :rules="nameRules"
                outlined
                rounded
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <p class="title">{{$vuetify.lang.t("$vuetify.liveDescription")}}</p>
              <v-textarea
                counter
                :rules="rules"
                :value="value"
                outlined
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col lg="6" md="6" sm="6" cols="12">
              <v-row>
                <v-col>
                  <p class="title">{{$vuetify.lang.t("$vuetify.Date")}}</p>
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="date"
                        label
                        prepend-icon="event"
                        hint="MM/DD/YYYY format"
                        persistent-hint
                        readonly
                        outlined
                        rounded
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="date" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                      <v-btn text color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row>
                <v-col lg="6" md="6" sm="6" cols="12">
                  <p class="title">{{$vuetify.lang.t("$vuetify.StartTime")}}</p>
                  <v-row>
                    <v-col lg="4" md="4" sm="4" cols="4">
                      <v-autocomplete v-model="start_time_hour" :items="hour" outlined></v-autocomplete>
                    </v-col>
                    <v-col lg="4" md="4" sm="4" cols="4">
                      <v-autocomplete v-model="start_time_minute" :items="minute" outlined></v-autocomplete>
                    </v-col>
                    <v-col lg="4" md="4" sm="4" cols="4">
                      <p>นาฬิกา</p>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col lg="6" md="6" sm="6" cols="12">
                  <p class="title">{{$vuetify.lang.t("$vuetify.EndTime")}}</p>
                  <v-row>
                    <v-col lg="4" md="4" sm="4" cols="4">
                      <v-autocomplete v-model="end_time_hour" :items="hour" outlined></v-autocomplete>
                    </v-col>
                    <v-col lg="4" md="4" sm="4" cols="4">
                      <v-autocomplete v-model="end_time_minute" :items="minute" outlined></v-autocomplete>
                    </v-col>
                    <v-col lg="4" md="4" sm="4" cols="4">
                      <p>นาฬิกา</p>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
            <v-col lg="6" md="6" sm="6" cols="12">
              <p class="title">{{$vuetify.lang.t("$vuetify.liveType")}}</p>
              <v-row>
                <v-col>
                  <v-radio-group class="mt-0" v-model="radios" :mandatory="false">
                    <v-radio :label="$vuetify.lang.t(`$vuetify.liveTypebyMyself`)" value="radio-1"></v-radio>
                    <v-radio :label="$vuetify.lang.t(`$vuetify.liveTypebyVideo`)" value="radio-2"></v-radio>
                  </v-radio-group>
                  <v-file-input
                    rounded
                    v-model="file_vedio"
                    color="deep-purple accent-4"
                    counter
                    placeholder="เลือกไฟล์วิดีโอที่ต้องการ"
                    outlined
                    :show-size="1000"
                    accept=".mp4"
                    prepend-icon="mdi-video"
                    @change="onFileVideoChange"
                  >
                    <template v-slot:selection="{ index, text }">
                      <v-chip
                        v-if="index < 2"
                        color="deep-purple accent-4"
                        dark
                        label
                        small
                      >{{ text }}</v-chip>

                      <span
                        v-else-if="index === 2"
                        class="overline grey--text text--darken-3 mx-2"
                      >+{{ files.length - 2 }} File(s)</span>
                    </template>
                  </v-file-input>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-form>-->
        <div class="scrollable">
          <selectStreamKey
            v-if="step === 1"
            :openDialog.sync="openSelectStreamKeyDialog"
            :courseId.sync="courseId"
            :liveId.sync="liveId"
            :changeStep.sync="changeStep"
          />
          <settingLive
            v-if="step === 2"
            :openDialog.sync="openSettingLiveDialog"
            :courseId.sync="courseId"
            :liveId.sync="liveId"
            :changeStep.sync="changeStep"
          />
          <liveConsole v-if="step === 3" :openDialog.sync="openLiveConsoleDialog" :courseId.sync="courseId" :liveId.sync="liveId" />
        </div>
        <!-- </v-card-text> -->
      </v-card>
      <!-- </div> -->
    </v-dialog>
  </div>
</template>
<script>
import selectStreamKey from '@/views/course/live/liveDialog/selectStreamkey.vue'
import settingLive from '@/views/course/live/liveDialog/settingLive.vue'
import liveConsole from '@/views/course/live/live.vue'
import { stopLiveStream, cancelLiveStream } from "@/service/course/live";
export default {
  components: {
    selectStreamKey,
    settingLive,
    liveConsole
  },
  props: {
    isLiveConsoleDialogOpen: {
      type: Boolean
    },
    closeLiveConsoleDialog: {
      type: Function
    },
    courseId: {
      type: String
    },
    liveId: {
      type: String
    },
    selectLive: {
      type: Object
    }
  },
  data() {
    return {
      // isLiveDialogOpen: false
      step: 0,
      openSettingLiveDialog: false,
      openSelectStreamKeyDialog: false,
      openLiveConsoleDialog: false,
    };
  },
  watch: {
    isLiveConsoleDialogOpen: async function(value) {
      if (value) {
        // this.step = this.selectLive.streamDetail.streamKey === 1 ?
        if (
          this.selectLive.streamDetail.streamKey === null ||
          this.selectLive.streamDetail.streamKey === ""
        ) {
          this.step = 1;
          this.openSelectStreamKeyDialog = true
          this.openSettingLiveDialog = false
          this.openLiveConsoleDialog = false
          // this.step = 3
        } else if (
          (this.selectLive.streamDetail.streamKey !== null ||
            this.selectLive.streamDetail.streamKey !== "") &&
          !this.selectLive.canWatch
        ) {
          this.step = 2;
          this.openSelectStreamKeyDialog = false
          this.openSettingLiveDialog = true
          this.openLiveConsoleDialog = false
          // this.step = 3
        } else {
          this.step = 3;
          this.openSelectStreamKeyDialog = false
          this.openSettingLiveDialog = false
          this.openLiveConsoleDialog = true
        }
      }
      else {
        // try{
        //   window.jwplayer().remove();
        // }catch(err){
        //   console.log(err)
        // }
      }
    }
  },
  methods: {
    changeStep(step) {
      this.step = step;
    },
    async cancelStream(){
      await cancelLiveStream({idcourse: this.courseId,idlivestream: this.liveId})
    },
    async closeLiveConsoleDialogAndClearStep () {
      this.step=0
      await this.closeLiveConsoleDialog()
    },
    async stopStream(){
      await this.cancelStream()
      let result= await stopLiveStream({idlivestream: this.liveId})
      if(result.status !== 403){
        await this.closeLiveConsoleDialog()
      }
    }
  }
};
</script>
<style scoped>
.v-sheet v-sheet--tile theme--dark v-toolbar v-toolbar--flat primary {
  height: 0;
}
.sizeImgDialogAdd {
  width: 120px;
  /* z-index: -1; */
  /* position: absolute;
  top: 40px;
  left: 40px; */
  /* width: 60%; */
  /* height: 70px; */
}
.v-sheet.v-sheet--tile.theme--dark.v-toolbar.v-toolbar--flat.primary {
  height: 20px !important;
}
.v-sheet.v-sheet--tile.theme--dark.v-toolbar.v-toolbar--flat.white {
  height: 20px !important;
}
.header-label {
  height: 40px !important;
  background-color: #50adde;
}
.header-label.logo {
  min-height: 50px !important;
  background-color: #ffffff;
  border-bottom: 1px solid #e4e4e4;
}
.header-label.logo img {
  /* height: 40px;
  vertical-align: middle;  */
}
.logo-nerdof {
  /* width: 10px; */
  padding: 10px;
  /* padding-right: 15px; */
  /* padding-left: 15px; */
  height: 44px;
  /* padding-bottom: 19.5px; */
  /* height: 100%; */
  vertical-align: middle;
  margin-top: 4px;
  margin-right: 0.5rem;
  margin-left: 20px;
}
.close_dialog {
  float: right;
  margin-right: 15px;
}
.end_boardcast {
  margin-top: 7px;
  font-size: 0.75rem !important;
}
.scrollable {
  overflow-y: auto;
  height: calc(100vh - 90px);
}
/* .container {
  background-color: #F8F8FA;
  width: 100%;
} */
</style>